import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=3bbdb53e&scoped=true&"
import script from "./ProductCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=3bbdb53e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbdb53e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealCardComponent: require('/app/appsumo/nuxt/components/common/DealCardComponent.vue').default,DealImpression: require('/app/appsumo/nuxt/components/common/DealImpression.vue').default,FlickingCarousel: require('/app/appsumo/nuxt/components/FlickingCarousel.vue').default})
